import { Box } from "@chakra-ui/layout";
import EmailPasswordVerification from "components/EmailPasswordVerification/EmailPasswordVerification";
import constant, { isDev } from "config/constant";
// import Wallet from "./pages/dashboard/wallet/Wallet";
// import WalletDeposit from "./pages/dashboard/wallet/WalletDeposit";
// import WalletTransactions from "./pages/dashboard/wallet/WalletTransactions";
// import WalletTransactionsOld from "./pages/dashboard/wallet/WalletTransactionsOld";
// import WalletView from "./pages/dashboard/wallet/WalletView";
// import WalletWithdraw from "./pages/dashboard/wallet/WalletWithdraw";
// dev pages for debugging
// INPL
import BCPLRoot from "pages/dashboard/BCPL";
import EarnRoot from "pages/dashboard/Earn";
import SwapRoot from "pages/dashboard/Swap";
// Bills pages
import BillsRoot from "pages/dashboard/Bills";
import CardsRoot from "pages/dashboard/Cards";
import HomeNotification from "pages/dashboard/home/HomeNotification";
//p2p v2
import P2p from "pages/dashboard/p2pv2/P2p";
import P2pBuyMakePayment from "pages/dashboard/p2pv2/P2pBuyMakePayment";
import P2pBuySellListing from "pages/dashboard/p2pv2/P2pBuySellListing";
import ReleaseTradeAsset from "pages/dashboard/p2pv2/ReleaseTradeAsset";
import TradeHistory from "pages/dashboard/p2pv2/TradeHistory";
import TechpointWidget from "pages/TechPointWidget";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
//Provider
import Provider from "store/index";
//css
import "./App.css";
// other
import Apple from "./components/other/appleSign";
//
import ProtectedRoute from "./components/ProtectedRoutes";
// Comps
import Reqs from "./components/requests";
import AppDownload from "./pages/app";
import ConfirmNumber2 from "./pages/auth/ConfirmNumber2";
import Forgot from "./pages/auth/ForgotPassword";
//auth
import Login from "./pages/auth/Login";
import Otp from "./pages/auth/Otp";
import PhoneNumber from "./pages/auth/PhoneNumber";
import Reset from "./pages/auth/Reset";
import TwoFAReset from "./pages/auth/Reset2FA";
import ResetCode from "./pages/auth/ResetCode";
import Signup from "./pages/auth/Signup";
import TwoFaEnter from "./pages/auth/TwoFaEnter";
import TwoFaGenerate from "./pages/auth/TwoFaGenerate";
import VerifyEmail from "./pages/auth/VerifyEmail";
import VerifyEmail2 from "./pages/auth/VerifyEmail2";
//account
import Account from "./pages/dashboard/account/AccountIndex";
// import AffiliateIndex from './pages/dashboard/account/AffiliatesIndex'
// import AccountBanks from "./pages/dashboard/account/AccountBanks";
// import AccountBVN from "./pages/dashboard/account/AccountBVN";
// import AccountEdit from "./pages/dashboard/account/AccountEdit";
// import AccountLevel2PrimaryVerification from "./pages/dashboard/account/AccountLevel2PrimaryVerification";
// import AccountLevel2SupportDocument from "./pages/dashboard/account/AccountLevel2SupportDocument";
// import AccountLevel2Verification from "./pages/dashboard/account/AccountLevel2Verification";
// import AccountLevel3Verification from "./pages/dashboard/account/AccountLevel3Verification";
// import AccountRefer from "./pages/dashboard/account/AccountRefer";
// import AccountSupport from "./pages/dashboard/account/AccountSupport";
// import AccountVerification from "./pages/dashboard/account/AccountVerification";
// import AccountVerify from "./pages/dashboard/account/AccountVerify";
import BuyAirtime from "./pages/dashboard/airtime/BuyAirtime";
//exchange
// import Exchange from "./pages/dashboard/exchange/Exchange";
// import ExchangeHistory from "./pages/dashboard/exchange/ExchangeHistory";
// import FundFromBank from "./pages/dashboard/home/BankFund";
import BankTransfer from "./pages/dashboard/home/BankTransfer";
import HomeCardPayment from "./pages/dashboard/home/CardPayment";
import HomeChangeraDeposit from "./pages/dashboard/home/ChangeraDeposit";
import FlutterwaveDeposit from "./pages/dashboard/home/FlutterwaveDeposit";
// import FundDetails from "./pages/dashboard/home/FundDetails";
// import HomeFundWallet from "./pages/dashboard/home/FundWallet";
//home
import Home from "./pages/dashboard/home/Home";
import Home3PBuy from "./pages/dashboard/home/Home3PBuy";
import Home3PBuyA from "./pages/dashboard/home/Home3PBuyAddress";
import HomeBuy from "./pages/dashboard/home/HomeBuy";
// import HomeNotifications from "./pages/dashboard/home/HomeNotifications";
import HomeReceive from "./pages/dashboard/home/HomeReceive";
import HomeSell from "./pages/dashboard/home/HomeSell";
import HomeSend from "./pages/dashboard/home/HomeSend";
// import HomeWithdraw from "./pages/dashboard/home/HomeWithdraw";
import InvoicePage from "./pages/dashboard/home/InvoicePage";
import Social from "./pages/dashboard/home/Social";
//p2p
// import P2P from "./pages/dashboard/p2p/P2P";
import P2PBuy from "./pages/dashboard/p2p/P2PBuy";
import P2PBuyAd from "./pages/dashboard/p2p/P2PBuyAd";
import P2PMListings from "./pages/dashboard/p2p/P2PMListings";
import P2PSell from "./pages/dashboard/p2p/P2PSell";
import P2PSellAd from "./pages/dashboard/p2p/P2PSellAd";
import P2PView from "./pages/dashboard/p2p/P2PView";
// import P2PV2 from "./pages/dashboard/p2pv2/P2pv2.js";
import P2PV2Create from "./pages/dashboard/p2pv2/P2pv2Create.jsx";
import P2PV2Edit from "./pages/dashboard/p2pv2/P2pv2Edit";
//wallet
// import WalletIndex from "./pages/dashboard/wallet/WalletIndex";
import WalletV2Root from "./pages/dashboard/wallet-v2/Root";
import P2PServerLogs from "./pages/logs/P2pLogs";
import MerchantPay from "./pages/MerchantPay";
// 404
import NotFound from "./pages/NotFound";
import StyledApp from "./StyledApp";

// import ls from "util/secureStorage";

const enableChangera = false;

function App() {
  useEffect(() => {
    const captcha = document.createElement("script");
    captcha.src = "https://www.google.com/recaptcha/api.js";
    captcha.async = true;
    captcha.defer = true;
    document.head.appendChild(captcha);
  }, []);

  return (
    <Provider>
      <StyledApp>
        <Box
          className="App"
          __css={{
            "--color": "#4E4B66",
            "--borderColor": "#D9DBE9",
            "--focusColor": "#06c34491",
            "--primary": "#03A438",
          }}
        >
          <Router>
            <Switch>
              <Route
                exact
                path={constant.PAGES.TECH_POINT_WIDGET}
                component={TechpointWidget}
              />
              <Route exact path={constant.PAGES.LOGIN} component={Login} />
              <Route exact path={constant.PAGES.APP} component={AppDownload} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/dashboard">
                <Redirect to={`/dashboard/home`} />
              </Route>
              <Route
                exact
                path={constant.PAGES.LOGIN}
                render={(props) => <Login {...props} />}
              />
              <Route path="login" component={Login} />

              <Route path={constant.PAGES.BCPL.ROOT} component={BCPLRoot} />
              <Route path={constant.PAGES.EARN.ROOT} component={EarnRoot} />
              <Route path={constant.PAGES.SWAP.ROOT} component={SwapRoot} />

              <Route path={constant.PAGES.SIGNUP} component={Signup} />
              <Route path={constant.PAGES.FORGOT} component={Forgot} />
              <Route path={constant.PAGES.RESET} component={Reset} />
              <Route
                path={constant.PAGES.VERIFY_TWO_FA}
                component={TwoFaEnter}
              />
              <Route
                path={constant.PAGES.VERIFY_PHONE}
                component={ConfirmNumber2}
              />
              {/* <Route path="/confirmnumber2" component={ConfirmNumber} /> */}

              <Route
                path={constant.PAGES.VERIFY_EMAIL}
                component={VerifyEmail2}
              />
              <Route path="/verifyemail2" component={VerifyEmail} />
              <Route
                path={constant.PAGES.PHONE_NUMBER}
                component={PhoneNumber}
              />
              <Route path={constant.PAGES.RESET_CODE} component={ResetCode} />
              <Route path="/otp" component={Otp} />
              <Route path="/2fagenerate" component={TwoFaGenerate} />

              <Route
                path={constant.PAGES.VERIFY_EMAIL_PASSWORD}
                component={EmailPasswordVerification}
              />

              {/* <ProtectedRoute
                path={constant.PAGES.VERIFY_EMAIL_PASSWORD}
                component={EmailPasswordVerification}
              /> */}

              <ProtectedRoute path="/dashboard/home" component={Home} />

              <ProtectedRoute path="/dashboard/bills" component={BillsRoot} />
              <ProtectedRoute path="/dashboard/cards" component={CardsRoot} />

              <ProtectedRoute path="/dashboard/social" component={Social} />
              <ProtectedRoute path="/dashboard/homebuy" component={HomeBuy} />
              <ProtectedRoute path="/dashboard/homesell" component={HomeSell} />
              <ProtectedRoute
                path="/dashboard/home3pbuy"
                component={Home3PBuy}
              />
              <ProtectedRoute
                path="/dashboard/home3pbuyaddress"
                component={Home3PBuyA}
              />
              {/* <ProtectedRoute
                path="/dashboard/homefundwallet"
                component={HomeFundWallet}
              /> */}
              <ProtectedRoute
                path="/dashboard/homecardpayment"
                component={HomeCardPayment}
              />
              {enableChangera ? (
                <ProtectedRoute
                  path="/dashboard/homechangeradeposit"
                  component={HomeChangeraDeposit}
                />
              ) : null}
              <ProtectedRoute
                path="/dashboard/homebanktransfer"
                component={BankTransfer}
              />
              {/* <ProtectedRoute
                path="/dashboard/fundfrombank"
                component={FundFromBank}
              /> */}
              {/* <ProtectedRoute
                path="/dashboard/funddetails"
                component={FundDetails}
              />
              <ProtectedRoute
                path="/dashboard/homewithdraw"
                component={HomeWithdraw}
              /> */}
              <ProtectedRoute
                path="/dashboard/homereceive"
                component={HomeReceive}
              />
              <ProtectedRoute path="/dashboard/homesend" component={HomeSend} />
              <ProtectedRoute
                path="/dashboard/homenotifications"
                component={HomeNotification}
              />

              {/* <ProtectedRoute path="/dashboard/exchange" component={Exchange} />
              <ProtectedRoute
                path="/dashboard/exchangehistory"
                component={ExchangeHistory}
              /> */}

              {/* <ProtectedRoute
                path="/dashboard/wallet"
                component={WalletIndex}
              /> */}
              <ProtectedRoute
                path="/dashboard/wallet"
                component={WalletV2Root}
              />
              {/* <ProtectedRoute
                path="/dashboard/walletview"
                component={WalletView}
              />

              <ProtectedRoute
                path="/dashboard/walletdeposit"
                component={WalletDeposit}
              />
              <ProtectedRoute
                path="/dashboard/walletwithdraw"
                component={WalletWithdraw}
              />
              <ProtectedRoute
                path="/dashboard/wallettransactions"
                component={WalletTransactions}
              />
              <ProtectedRoute
                path="/dashboard/wallettransactionsold"
                component={WalletTransactionsOld}
              /> */}

              {/* <ProtectedRoute path="/dashboard/p2p" component={P2P} /> */}
              <ProtectedRoute
                path="/dashboard/p2pmlistings"
                component={P2PMListings}
              />
              <ProtectedRoute path="/dashboard/p2pbuy" component={P2PBuy} />
              <ProtectedRoute path="/dashboard/p2pbuyad" component={P2PBuyAd} />
              <ProtectedRoute path="/dashboard/p2psell" component={P2PSell} />
              <ProtectedRoute
                path="/dashboard/p2psellad"
                component={P2PSellAd}
              />
              <ProtectedRoute path="/dashboard/p2pview" component={P2PView} />

              <ProtectedRoute path="/dashboard/p2p" component={P2p} />
              <ProtectedRoute
                path="/dashboard/p2p/create"
                component={P2PV2Create}
              />
              <ProtectedRoute
                path="/dashboard/p2p/:id/buy"
                component={P2pBuySellListing}
              />
              <ProtectedRoute
                path="/dashboard/p2p/trade/:id/session"
                component={P2pBuyMakePayment}
              />
              <ProtectedRoute
                path="/dashboard/p2p/trades"
                component={TradeHistory}
              />
              <ProtectedRoute
                path="/dashboard/p2p/trade/:id/order"
                component={ReleaseTradeAsset}
              />
              <ProtectedRoute
                path="/dashboard/p2p/edit/:id"
                component={P2PV2Edit}
              />

              <ProtectedRoute path="/dashboard/account" component={Account} />
              {/* <ProtectedRoute
                path="/dashboard/accountedit"
                component={AccountEdit}
              />
              <ProtectedRoute
                path="/dashboard/accountbanks"
                component={AccountBanks}
              />
              <ProtectedRoute
                path="/dashboard/accountbvn"
                component={AccountBVN}
              />
              <ProtectedRoute
                path="/dashboard/accountrefer"
                component={AccountRefer}
              />
              <ProtectedRoute
                path="/dashboard/accountsupport"
                component={AccountSupport}
              />
              <ProtectedRoute
                path="/dashboard/accountverify"
                component={AccountVerify}
              />
              <ProtectedRoute
                path="/dashboard/accountVerification"
                component={AccountVerification}
              />
              <ProtectedRoute
                path="/dashboard/accountLevel2Verification"
                component={AccountLevel2Verification}
              /> */}
              {/* <ProtectedRoute
                path="/dashboard/accountLevel2PrimaryVerification"
                component={AccountLevel2PrimaryVerification}
              />

              <ProtectedRoute
                path="/dashboard/accountLevel2SupportDocument"
                component={AccountLevel2SupportDocument}
              />
              <ProtectedRoute
                path="/dashboard/accountLevel3Verification"
                component={AccountLevel3Verification}
              /> */}
              <ProtectedRoute
                path="/dashboard/buyairtime"
                component={BuyAirtime}
              />
              <ProtectedRoute path="/merchantpay" component={MerchantPay} />

              <Route path="/reqs" component={Reqs} />
              <Route path="/apple" component={Apple} />
              <Route path="/invoice" component={InvoicePage} />

              {isDev && (
                <ProtectedRoute path="/p2plogs" component={P2PServerLogs} />
              )}
              <ProtectedRoute
                path="/dashboard/fundfw"
                component={FlutterwaveDeposit}
              />

              <Route path={constant.PAGES.TwoFAReset} component={TwoFAReset} />

              <Route component={NotFound} />
            </Switch>
          </Router>
        </Box>
      </StyledApp>
    </Provider>
  );
}

export default App;
